<template>
	<nav
		class="main-header navbar navbar-expand navbar-white navbar-light bg-white text-dark font-weight-bold elevation-1"
	>
		<ul class="navbar-nav align-middle">
			<li class="nav-item nav-focus nav-brand">
				<a
					class="nav-link text-dark"
					data-widget="pushmenu"
					href="#"
					role="button"
					style="font-family: NunitoBlack"
					><i class="fas fa-bars"></i>&nbsp;&nbsp;
					<span class="full-text">Speke Management System</span>
					<span class="short-text">SMS</span></a
				>
			</li>
			<li class="nav-item nav-focus d-none">
				Budget Information System (BIS):
			</li>
		</ul>

		<ul class="navbar-nav ml-auto">
			<li class="nav-item d-none">
				<a class="nav-link" data-widget="navbar-search" href="#" role="button">
					<i class="fas fa-search"></i>
				</a>
				<div class="navbar-search-block">
					<form class="form-inline">
						<div class="input-group input-group-sm">
							<input
								class="form-control form-control-navbar"
								type="search"
								placeholder="Search"
								aria-label="Search"
							/>
							<div class="input-group-append">
								<button class="btn btn-navbar" type="submit">
									<i class="fas fa-search"></i>
								</button>
								<button
									class="btn btn-navbar"
									type="button"
									data-widget="navbar-search"
								>
									<i class="fas fa-times"></i>
								</button>
							</div>
						</div>
					</form>
				</div>
			</li>

			<li class="nav-item dropdown d-inline-block">
				<a
					class="nav-link dropdown-toggle"
					data-toggle="dropdown"
					href="#"
					role="button"
				>
					<img
						src="/adminlte/dist/img/placeholder.jpg"
						class="img-circle elevation-2"
						alt="User Image"
						style="width: 30px; height: 30px; object-fit: cover"
					/>
					<span v-if="user" class="ms-2 d-xl-inline-block">
						{{ user.data.name }}
					</span>
				</a>
				<div
					class="dropdown-menu dropdown-menu-end font-size-14 rounded-0 custom-header w-100"
				>
					<a class="dropdown-item" href="/profile">
						<i class="far fa-user me-2"></i>
						<span>Personal Profile</span>
					</a>
					<a class="dropdown-item" href="/paxroster">
						<i class="far fa-clock me-2"></i>
						<span>Personal Leave</span>
					</a>
					<div class="dropdown-divider"></div>
					<a
						class="dropdown-item text-danger"
						href="#"
						@click.prevent="logout()"
					>
						<i class="fas fa-power-off me-2"></i>
						<span>Logout</span>
					</a>
				</div>
			</li>
			<li class="nav-item d-none">
				<a class="nav-link" data-widget="fullscreen" href="#" role="button">
					<i class="fas fa-expand-arrows-alt"></i>
				</a>
			</li>
			<li class="nav-item d-none">
				<a
					class="nav-link"
					data-widget="control-sidebar"
					data-slide="true"
					href="#"
					role="button"
				>
					<i class="fas fa-th-large"></i>
				</a>
			</li>
		</ul>
	</nav>
</template>

<style>
.navbar-nav {
	display: flex;
	align-items: center; /* Aligns items vertically */
}

.nav-item {
	margin-right: 20px; /* Adjust margin as needed */
}

.nav-focus {
	font-size: 20px; /* Ensure uniform font size */
}

/* Default: Show full text and hide short text */
.nav-brand .full-text {
	display: inline;
}
.nav-brand .short-text {
	display: none;
}

/* For small screens: Show short text and hide full text */
@media (max-width: 768px) {
	.nav-brand .full-text {
		display: none;
	}
	.nav-brand .short-text {
		display: inline;
	}
}

.dropdown-item {
	width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>

